import React, { useState } from 'react';
import { Text, View, TextInput, Switch, StyleSheet } from 'react-native';
import styles from '@stylesheet';
import updateStoreHandler from '../utils/updateStoreHandler';
import DropDownPicker from 'react-native-dropdown-picker';
import toTitleCase from '@hooks/toTitleCase';
import * as Animatable from 'react-native-animatable';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const TextValidation = ({ index, item }: any) => {
  const theme = themeSelector();

  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'multiline', label: 'Multiline?', type: 'switch' },
    { key: 'fieldType', label: 'Field Type', type: 'dropdown', enum: ['text', 'email', 'password'] },
    { key: 'placeholder', label: 'Placeholder', type: 'textInput' },
    { key: 'minCharacters', label: 'Min Characters', type: 'textInput', inputMode: 'numeric' },
    { key: 'maxCharacters', label: 'Max Characters', type: 'textInput', inputMode: 'numeric' },
    { key: 'minWords', label: 'Min Words', type: 'textInput', inputMode: 'numeric' },
    { key: 'maxWords', label: 'Max Words', type: 'textInput', inputMode: 'numeric' },
    // Add more types as needed
  ];


  return (
    <View style={[localStyles.modernValidationView, { backgroundColor: theme ? '#f8fafc' : '#0f172a' }]}>
      {validationComponents.map((component, idx) => (
        <View key={component.key + 'field' + idx} style={localStyles.fieldContainer}>
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};

const localStyles = StyleSheet.create({
  modernValidationView: {
    padding: 16,
    borderRadius: 12,
    gap: 12,
  },
  fieldContainer: {
    width: '100%',
  }
});

export default TextValidation;
